import type { CrmContactAddress } from "@/lib/crmContactAddresses";
import type { CrmContactEmail, CrmContactPhone, CrmContactSocial } from "@/lib/crmContactChannels";

export const CRM_LEAD_CHANNELS_SOURCE_DETAIL_MARKER = "__crm_channels_v1:";

export type LeadSourceDetailChannelBucket = {
  emails?: CrmContactEmail[];
  phones?: (CrmContactPhone & { smsOptIn?: boolean })[];
  socials?: CrmContactSocial[];
  addresses?: CrmContactAddress[];
};

export type LeadSourceDetailChannelOverflow = {
  contact?: LeadSourceDetailChannelBucket;
  company?: LeadSourceDetailChannelBucket;
  attachedContacts?: LeadSourceDetailChannelBucket[];
  attachAccountIds?: string[];
};

export function parseLeadSourceDetailChannelOverflow(
  sourceDetail?: string | null,
): LeadSourceDetailChannelOverflow | null {
  const raw = sourceDetail?.trim();
  if (!raw?.startsWith(CRM_LEAD_CHANNELS_SOURCE_DETAIL_MARKER)) return null;
  try {
    const parsed = JSON.parse(raw.slice(CRM_LEAD_CHANNELS_SOURCE_DETAIL_MARKER.length)) as unknown;
    if (!parsed || typeof parsed !== "object") return null;
    return parsed as LeadSourceDetailChannelOverflow;
  } catch {
    return null;
  }
}
